import { createApp } from "vue";
import { createPinia } from "pinia";
import { ImagePreview, ActionSheet, SwipeCell,Loading, Tab, Tabs,List,Dialog } from 'vant';
import router from '@/router'
import 'vant/lib/index.css';
import '@/assets/css/index.scss';
import touch from '@/assets/js/touch'
const pinia = createPinia();
import App from "./main.vue";
const app = createApp(App).use(router)

import VueVirtualScroller from "vue-virtual-scroller"
import "vue-virtual-scroller/dist/vue-virtual-scroller.css"
app.config.globalProperties.$goToUniPage = (url, type = 'navigateTo') => {
  if (typeof uni !== 'undefined' && uni[type]) {
    uni[type]({ url })
  } else {
    console.error(`[Bridge Error] uni is not ready or ${type} is not a function.`)
  }
}

app.use(VueVirtualScroller) 
app.use(touch, {time: 2500})
app.use(pinia)
app.use(ImagePreview).use(ActionSheet).use(SwipeCell).use(Loading).use(Tab).use(Tabs).use(List).use(Dialog);
app.mount("#app");
